import { render, staticRenderFns } from "./yowhatsapp.vue?vue&type=template&id=944443c0&scoped=true"
import script from "./yowhatsapp.vue?vue&type=script&lang=js"
export * from "./yowhatsapp.vue?vue&type=script&lang=js"
import style0 from "./yowhatsapp.vue?vue&type=style&index=0&id=944443c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944443c0",
  null
  
)

export default component.exports